// flow weak

import React, {
  PureComponent
}                             from 'react';
import PropTypes              from 'prop-types';
import AnimatedView           from '../../../../components';
import styles                 from './style'
import {
  defaultOptions,
  checkStatus,
  parseJSON,
  getLocationOrigin
}                     from '../../../../services/fetchTools';
import {Link} from 'react-router-dom';
import { withRouter } from 'react-router';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import Checkbox from 'material-ui/Checkbox';
import { Multiselect } from 'react-widgets';



class EditLead extends PureComponent {
  static propTypes = {
    actions: PropTypes.shape({
      enterPage: PropTypes.func,
      leavePage: PropTypes.func,
    })
  };

  constructor(props) {
    super(props);
    this.state = {
      id: props.match.params.id,
      lead: {
        "lead_id": "",        
        "customer": '',
        "mobile_no": '',
        "venue_id": "",
        "game_type_id": "",
        "follow_up_date": moment().format("YYYY-MM-DD"),
        "status": "",
        "comment": "",
        "buddy_id": "",
        "quality": "",
        "email":"",
        "programs":[],
        "games":[]
      },
      
      selected_lead_programs:[],
      selected_lead_games: [],
      selected_programs :[],
      temp_lead_programs:[],
      temp_selected_programs:[],

      venues: [],
      game_type: [],
      statuses: [],
      buddies: [],
      all_games: [],
      customerhistory: '',
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleStartDate = this.handleStartDate.bind(this);
    this.onProgramSelect = this.onProgramSelect.bind(this);
    this.onProgramChange = this.onProgramChange.bind(this);
    this.onLeadChange = this.onLeadChange.bind(this);
    this.onLeadSelect = this.onLeadSelect.bind(this);

  }

  handleStartDate(date){
    var new_selected_one =  Object.assign({}, this.state.lead);
    new_selected_one['follow_up_date'] = date
    this.setState({lead: new_selected_one});
  }

  componentDidMount() {
    this.getGames();
    this.getFixtureList();
    this.getStatusList();
    this.buddyList();
    this.getLeadDetails();
    this.getLeadHistory();
  }

  getGames(){
       const url = `${getLocationOrigin()}/court/get_games_list/`;
        const options = {...defaultOptions};
  
       return fetch(url, options)
          .then(checkStatus)
          .then(parseJSON)
          .then(data => this.setState({all_games:data.result}))
          .catch(error => error);
     }


  getLeadHistory(){
    const url = `${getLocationOrigin()}/lead/customer_lead_list/`;
    const options = {...defaultOptions};
    options['method'] = 'post';
    options['headers'] = {'content-type': 'application/json'}
    options['body'] = JSON.stringify({'customer_id': this.state.id});
    console.log('Going to fetch');
    return fetch(url, options)
      .then(checkStatus)
      .then(parseJSON)
      .then(response =>
        this.setState({customerhistory: response.data})
      )
      .catch(error => {
        console.log(error);
        alert(error.message);
      });
  }
  getLeadDetails(){
    const url = `${getLocationOrigin()}/lead/get_last_lead/?customer_id=${this.state.id}`;
     const options = {...defaultOptions};

    return fetch(url, options)
       .then(checkStatus)
       .then(parseJSON)
       .then(data => this.setState({ lead: data.lead,selected_lead_games:data.lead.games,selected_programs:data.lead.programs},()=>{
        this.filteredData();
       }))
       .catch(error => error);


  }
  filteredData(){

    var filtered_games = this.state.all_games.filter(game=> this.state.selected_lead_games.includes(game.pk))
      console.log(filtered_games)
      this.setState({selected_lead_games:filtered_games})

  }

  getStatusList(){
    const url = `${getLocationOrigin()}/lead/create_lead_status/`;
     const options = {...defaultOptions};

    return fetch(url, options)
       .then(checkStatus)
       .then(parseJSON)
       .then(data => this.setState({ statuses: data.statuses}))
       .catch(error => error);

  }
  buddyList(){
    const url = `${getLocationOrigin()}/cm/list_all_buddies/`;
     const options = {...defaultOptions};

    return fetch(url, options)
       .then(checkStatus)
       .then(parseJSON)
       .then(data => this.setState({ buddies: data.data}))
       .catch(error => error);

  }

  getFixtureList() {
     const url = `${getLocationOrigin()}/eagleeye/get_details_for_fixture_creation/`;
     const options = {...defaultOptions};

    return fetch(url, options)
       .then(checkStatus)
       .then(parseJSON)
       .then(data => this.setState({ venues: data.venues, game_types: data.game_type}))
       .catch(error => error);
  }

  postEditedMatch(data, props) {
    var date = moment(data.follow_up_date).format("YYYY-MM-DD");
    const url = `${getLocationOrigin()}/lead/change_lead/`;
    const options = {...defaultOptions};
    options['method'] = 'post';
    options['headers'] = {'content-type': 'application/json'}
    options['body'] = JSON.stringify({'lead_id': this.state.lead.id,
                                      'buddy_id': data.buddy_id,
                                        'status': data.status,
                                        'follow_up_date': date,
                                        'customer_game_type': data.game_type_id,
                                        'comment': data.comment,
                                       'venue': data.venue_id,
                                       'quality': data.quality });
    console.log('Going to fetch');
    return fetch(url, options)
      .then(checkStatus)
      .then(parseJSON)
      .then(function(response){                      // first then()
          alert(response.message);
      })
      .catch(error => {
        console.log(error);
        alert(error.message);
      });
  }

  saveChanges(props,data,games,programs){
    if (this.state.lead.quality == 'Will Not Pay' || this.state.lead.quality == 'No Response' ||this.state.lead.quality == 'May Pay'||this.state.lead.quality == 'Highly Likely' ||this.state.lead.quality == 'Will Not Pay' ||this.state.lead.quality == 'Sure Payment' ){
      var qualities = {'Will Not Pay':'1','No Response':'2','May Pay':'3','Highly Likely':'4','Sure Payment':'5'} 
      var quality_value =  qualities[this.state.lead.quality]
    }else{
      quality_value = this.state.lead.quality
    }

      var date = moment(data.follow_up_date).format("YYYY-MM-DD");
      const url = `${getLocationOrigin()}/lead/save_lead_changes/`;
      const options = {...defaultOptions};
      options['method'] = 'post';
      options['headers'] = {'content-type': 'application/json'}
      options['body'] = JSON.stringify({
                                        'customer_id': data.customer_id,
                                        'name': data.customer,
                                        'comment': data.comment,
                                        'quality': quality_value,
                                        'status': data.status,
                                        'email': data.email,
                                        'follow_up_date': date,
                                        'selected_games': games,
                                        'selected_locations': [],
                                        'venue': data.venue_id,
                                        'selected_programs':programs,
                                        'buddy_id':data.buddy_id

                                      });
      console.log('Going to fetch');
      return fetch(url, options)
        .then(checkStatus)
        .then(parseJSON)
        .then(response => {                     
            alert(response.message);
        })
        .catch(error => {
          console.log(error);
          alert(error.message);
        });
    }
  
  onLeadSelect(optionsList,selectedItem) {
      var name = optionsList.name ;
      this.state.temp_lead_programs.push(optionsList)
      this.setState({ selected_lead_games: this.state.temp_lead_programs});
      
    }

    onLeadChange(dataItem,event){
      var name = event.dataItem.name
      if(name === 'game'){
        this.setState({page:1, selected_lead_games:dataItem.map(x => x)});
      }
    }

    onProgramSelect(optionsList,selectedItem){
      var program = this.state.selected_programs;
      program.push(selectedItem)
      this.setState({selected_programs:program})
    }

    onProgramChange(dataItem,event){
      this.setState({selected_programs:dataItem.map(x => x)})
    }


  handleChange(event) {
    console.log('handleChange..')
    console.log(event.target.value)
    const name = event.target.name;
    var new_selected_one = Object.assign({}, this.state.lead);
    new_selected_one[name] = event.target.value
    this.setState({lead: new_selected_one});
  }

  handleSubmit(event) {
    event.preventDefault();
    var selected_games = []
    var selected_programs = this.state.selected_programs

    this.state.selected_lead_games.forEach(data=>{
        selected_games.push(data.pk)
      })
    
    if(this.state.lead.comment.length == 0){
      alert('Please provide comment for changes')
    }
    else if(selected_programs.length == 0 && selected_games.length > 0){
      alert('Please select at least one program')
    }
    else if(selected_programs.length > 0 && selected_games.length == 0){
      alert('Please select at least one game for selected program')
    }
    else{
      console.log('values')
      console.log(this.state.lead)
      this.saveChanges(this.props,this.state.lead,selected_games,selected_programs)
    }
  }


  render() {
    var programs = ['Adults Playing','Adults Training','Kids Coaching','Court Rental']
    var qualities = {'Will Not Pay':'1','No Response':'2','May Pay':'3','Highly Likely':'4','Sure Payment':'5'} 
    var quality_value =  qualities[this.state.lead.quality]
    return(
      <div style={styles.container}>
        <div className="row col-md-8 table-bordered" style={styles.table}>
          <div style={styles.main_header} className="col-md-12">
            <h3 style={{textAlign:'center'}}>Edit Lead</h3>
          </div>
          <form  className="validated-form form-horizontal" onSubmit={this.handleSubmit}>

            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Customer 
              </div>
              <div className="col-md-6 input-group">
                {this.state.lead.customer} - {this.state.lead.mobile_no}
              </div>
            </div>
            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className='col-md-6' >
                Email 
              </div>
              <input className="col-md-6" style={styles.item_body} name="email" value={this.state.lead.email}
              onChange={this.handleChange} />
            </div>
            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Lead Quality
              </div>
              <select name="quality" className="col-md-6" style={styles.item_body} value={quality_value}
                onChange={this.handleChange}>
                  <option value={1}>1</option>
                  <option value={2}>2</option>
                  <option value={3}>3</option>
                  <option value={4}>4</option>
                  <option value={5}>5</option>
              </select>
            </div>

           <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Venue
              </div>
              <select name="venue_id" className="col-md-6" style={styles.item_body} value={this.state.lead.venue_id}
                onChange={this.handleChange}>
                { this.state.venues ?
                  this.state.venues.map((x, index) => (
                  <option key={x.id} value={x.id}>{x.name}</option>
                  ))
                  :
                  <option>Loading....</option>
                }
              </select>
            </div>
            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Games
              </div>
              <div style={styles.item_body} className="col-md-6">
                {this.state.all_games.length>0 && 
                  <Multiselect
                    placeholder="Game Interested"
                    data={this.state.all_games}
                    textField='game'
                    onSelect={this.onLeadSelect} 
                    onChange={this.onLeadChange}
                    filter='contains' 
                    value = {this.state.selected_lead_games}
                   />
                  } 
              </div>
            </div>
            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Game Type
              </div>
              <select name="game_type_id" className="col-md-6" style={styles.item_body} value={this.state.lead.game_type_id}
                onChange={this.handleChange}>
                { this.state.game_types ? 
                  this.state.game_types.map((x, index) => (
                  <option key={x.pk} value={x.pk}>{x.game + ' ' + x.name}</option>
                  ))
                  :
                  <option>Loading...</option>
                }
              </select>
            </div>
            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Programs
              </div>
              <div style={styles.item_body} className="col-md-6" >
                {programs.length>0 && 
                  <Multiselect
                    placeholder="Program Interested"
                    data={programs}
                    onSelect={this.onProgramSelect} 
                    onChange={this.onProgramChange}
                    filter='contains'
                    value = {this.state.selected_programs} 
                   />
                  } 
              </div> 
              </div>

            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Follow up Date
              </div>
              <DatePicker selected={moment(this.state.lead.follow_up_date)} onChange={this.handleStartDate}/>
            </div>
            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Status
              </div>
              <select name="status" className="col-md-6" style={styles.item_body} value={this.state.lead.status}
                onChange={this.handleChange} disabled={this.state.lead.status == 70 ? 'disabled': ''}>
                { this.state.statuses ? 
                  this.state.statuses.map((x, index) => (
                  <option key={x.id} value={x.id}>{x.status}</option>
                  ))
                  :
                  <option>Loading...</option>
                }
              </select>
            </div>
            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Buddies
              </div>
              <select name="buddy_id" className="col-md-6" style={styles.item_body} value={this.state.lead.buddy_id}
                onChange={this.handleChange}>
                <option>------</option>
                { this.state.buddies ? 
                  this.state.buddies.map((x, index) => (
                  <option key={x.id} value={x.id}>{x.buddy}</option>
                  ))
                  :
                  <option>Loading...</option>
                }
              </select>
            </div>
           
            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Comments
              </div>
              <div className="col-md-6 input-group">
                <textarea rows="4" cols="33" id="comments" name="comment" placeholder={this.state.lead.comment} onChange={this.handleChange}>
                {this.state.lead.comment}
                </textarea>
              </div>
            </div>
            
            <div style={styles.button_submit} className="col-md-12">
              <input className="btn btn-lg" type="submit" value="Submit" style={{backgroundColor:'#302C35',
                color:'#ffffff'}}/>
            </div>
            <div className="col-md-12">
              {this.state.data_uploaded?<div className="text-success" style={styles.success}>* Fixture created successfully.</div>:''}
              {this.state.data_error?<div className="text-danger" style={styles.success}>* Error, creation failed.</div>:''}
            </div>
          </form>
          

        </div>
      </div>
    );
  }
}

export default EditLead;



// WEBPACK FOOTER //
// ./src/app/views/partner/crud/editLead/index.js